import { Component } from '@angular/core';

import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HomeService } from '../services/home.service';
import { NgToastService } from 'ng-angular-popup';
import { PreviewUrls } from '../preview-urls';
import { Router } from '@angular/router';

@Component({
  selector: 'app-proprietorkyc',
  templateUrl: './proprietorkyc.component.html',
  styleUrls: ['./proprietorkyc.component.scss'],
})
export class ProprietorkycComponent {
  propriotorForm!: FormGroup;
  otherForm!: FormGroup;
  pvtForm!: FormGroup;
  isProprietor: boolean = true;
  selectedFile: any;
  selectedFileGST: any;
  isSubmit: boolean = false;
  isPvt: boolean = false;
  isLpp: boolean=false;
  userKycDetails: any;
  //desable form after click on url
  kycGet() {
    this.home.getUserKyc().subscribe((res: any) => {
      this.userKycDetails = res;
      console.log('newwwwwwwwNames',this.userKycDetails)
    })
  }
  //end
  constructor(private fb: FormBuilder, private home: HomeService, private toast: NgToastService,   private router: Router ) {
    this.propriotorForm = this.fb.group({
      business_type: ['Proprietor'],
      proprietor_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      proprietor_pan: ['', [Validators.required, Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
      proprietor_gst: ['', [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$')]],
      bank_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      account_number: ['', [Validators.required, Validators.pattern('^[0-9]{9,18}$')]],
      ifsc_code: ['', [Validators.required, Validators.pattern('^[A-Z]{4}0[A-Z0-9]{6}$')]],
      account_holder_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      proprietor_pan_image: ['', [Validators.required]],
      proprietor_gst_image: ['', [Validators.required]],
    });

    this.otherForm = this.fb.group({
      business_type: [''],
      director_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      director_mobile: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      director_aadhar: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      director_pan: ['', [Validators.required, Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
      director_gst: ['', [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$')]],
      director_cin: ['', [Validators.required]],
      bank_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      account_number: ['', [Validators.required, Validators.pattern('^[0-9]{9,18}$')]],
      ifsc_code: ['', [Validators.required, Validators.pattern('^[A-Z]{4}0[A-Z0-9]{6}$')]],
      account_holder_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      director_aadhar_front_image: ['', [Validators.required]],
      director_aadhar_back_image: ['', [Validators.required]],
      cin_number_image: ['', [Validators.required]],
      profile_picture: ['', [Validators.required]],
      director_pan_image: ['', [Validators.required]],
      director_gst_image: ['', [Validators.required]],
    });
    this.pvtForm = this.fb.group({
      business_type: [''],
      director_nameone: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      director_mobile: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      director_aadharone: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      director_panone: ['', [Validators.required, Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
      director_gst: ['', [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$')]],
      director_cin: ['', [Validators.required]],
      bank_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      account_number: ['', [Validators.required, Validators.pattern('^[0-9]{9,18}$')]],
      ifsc_code: ['', [Validators.required, Validators.pattern('^[A-Z]{4}0[A-Z0-9]{6}$')]],
      account_holder_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      director_aadhar_front_imageone: ['', [Validators.required]],
      director_aadhar_back_imageone: ['', [Validators.required]],
      cin_number_image: ['', [Validators.required]],
      profile_picture: ['', [Validators.required]],
      director_pan_imageone: ['', [Validators.required]],
      director_gst_image: ['', [Validators.required]],
      // director Two
      director_nametwo: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+(?:[- s][a-zA-Z]+)*$')]],
      // director_aadhartwo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      // director_aadhar_front_imagetwo: ['', [Validators.required]],
      // director_aadhar_back_imagetwo: ['', [Validators.required]],
      // director_pantwo: ['', [Validators.required, Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')]],
      // director_pan_imagetwo: ['', [Validators.required]],

    });
  }
  previewUrls: PreviewUrls = {};
menuKyc=["Proprietor","LLP","Pvt LTD","LTD"];
  onFileSelected(event: any, imageKey: string, previewUrlKey: string) {
    this.selectedFile = event.target.files[0];
    const formData = new FormData();
    formData.append(imageKey, this.selectedFile);
    this.home.imgUpload(formData).subscribe((res: any) => {
      this.otherForm.get(imageKey)?.setValue(res[imageKey]);
      // Set the previewUrl dynamically
      this.previewUrls[previewUrlKey] = res[previewUrlKey];
      this.previewImage(previewUrlKey);

    });
  }
  // onFileSelectedPro(event: any, imageKey: string, previewUrlKey: string) {
  //   this.selectedFile = event.target.files[0];
  //   const formData = new FormData();
  //   formData.append(imageKey, this.selectedFile);
  //   this.home.imgUpload(formData).subscribe((res: any) => {
  //     this.propriotorForm.get(imageKey)?.setValue(res[imageKey]);
  //     // Set the previewUrl dynamically
  //     this.previewUrls[previewUrlKey] = res[previewUrlKey];
  //     this.previewImage(previewUrlKey);

  //   });
  // }

  // In your component
selectedFiles: { [key: string]: File } = {};

// onFileSelectedPro(event: any, imageKey: string, previewUrlKey: string) {
//   const file = event.target.files[0];
//   if (!file) return;

//   // Local preview immediately
//   const reader = new FileReader();
//   reader.onload = (e: any) => {
//     this.previewUrls[previewUrlKey] = e.target.result;
//   };
//   reader.readAsDataURL(file);

//   const formData = new FormData();

//   const fieldNameMap: { [key: string]: string } = {
//     'proprietor_pan_image': 'transaction_image',
//     'proprietor_gst_image': 'transaction_image',
//     'director_aadhar_front_image': 'transaction_image',
//     'director_aadhar_back_image': 'transaction_image',
//     'cin_number_image': 'transaction_image',
//     'profile_picture': 'transaction_image'
//   };

//   const apiFieldName = fieldNameMap[imageKey] ?? imageKey;
//   formData.append(apiFieldName, file, file.name);

//   this.home.imgUpload(formData).subscribe({
//     next: (res: any) => {
//       console.log('Full API response:', res); // 👈 paste this output here

//       // Try all possible response keys
//       const uploadedUrl = res[imageKey]        // res.proprietor_pan_image
//         ?? res['transaction_image']            // res.transaction_image
//         ?? res?.data?.[imageKey]              // res.data.proprietor_pan_image
//         ?? res?.data?.url                     // res.data.url
//         ?? res?.url                           // res.url
//         ?? res?.path                          // res.path
//         ?? res?.image_url;                    // res.image_url

//       if (uploadedUrl) {
//         this.propriotorForm.get(imageKey)?.setValue(uploadedUrl);
//         this.propriotorForm.get(imageKey)?.markAsTouched();
//         this.propriotorForm.get(imageKey)?.markAsDirty();
//         console.log('Form value set:', uploadedUrl);
//         console.log('Form valid:', this.propriotorForm.valid);
//       } else {
//         console.error('Could not find URL in response:', res);
//       }
//     },
//     error: (err) => {
//       console.error('Upload error:', err.error);
//     }
//   });
// }


// onFileSelectedPro(event: any, imageKey: string, previewUrlKey: string, form: FormGroup = this.propriotorForm) {
//   const file = event.target.files[0];
//   if (!file) return;


  
//   const reader = new FileReader();
//   reader.onload = (e: any) => {
//     this.previewUrls[previewUrlKey] = e.target.result;
//   };

//   reader.readAsDataURL(file);

//   const formData = new FormData();

//   // const fieldNameMap: { [key: string]: string } = {
//   //   'proprietor_pan_image': 'transaction_image',
//   //   'proprietor_gst_image': 'transaction_image',
//   //   'director_aadhar_front_image': 'transaction_image',
//   //   'director_aadhar_back_image': 'transaction_image',
//   //   'cin_number_image': 'transaction_image',
//   //   'profile_picture': 'transaction_image'
//   // };

//   const fieldNameMap: { [key: string]: string } = {
//   'proprietor_pan_image': 'transaction_image',
//   'proprietor_gst_image': 'transaction_image',
//   'director_aadhar_front_image': 'transaction_image',
//   'director_aadhar_back_image': 'transaction_image',
//   'director_pan_image': 'transaction_image',
//   'director_gst_image': 'transaction_image',
//   'director_aadhar_front_imageone': 'transaction_image',
//   'director_aadhar_back_imageone': 'transaction_image',
//   'director_pan_imageone': 'transaction_image',
//   'cin_number_image': 'transaction_image',
//   'profile_picture': 'transaction_image'
// };

//   const apiFieldName = fieldNameMap[imageKey] ?? imageKey;
//   formData.append(apiFieldName, file, file.name);

//   this.home.imgUpload(formData).subscribe({
//     next: (res: any) => {
//       console.log('Full API response:', res);

//       const uploadedUrl = res[imageKey]
//         ?? res['transaction_image']
//         ?? res?.data?.[imageKey]
//         ?? res?.data?.url
//         ?? res?.url
//         ?? res?.path
//         ?? res?.image_url;

//       if (uploadedUrl) {
//         form.get(imageKey)?.setValue(uploadedUrl);
//         form.get(imageKey)?.markAsTouched();
//         form.get(imageKey)?.markAsDirty();
//         console.log('Form value set:', uploadedUrl);
//         console.log('Form valid:', form.valid);
//       } else {
//         console.error('Could not find URL in response:', res);
//       }
//     },
//     error: (err) => {
//       console.error('Upload error:', err.error);
//     }
//   });
// }

onFileSelectedPro(event: any, imageKey: string, previewUrlKey: string, form: FormGroup = this.propriotorForm) {
  const file = event.target.files[0];
  if (!file) return;

  // control ని programmatic గా clear చేస్తుంది, కానీ ఇప్పుడు formControlName లేదు కాబట్టి
  // DOM లోని "chosen filename" display మీద ఇది ప్రభావం చూపదు
  form.get(imageKey)?.setValue('');

  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.previewUrls[previewUrlKey] = e.target.result;
  };
  reader.readAsDataURL(file);

  const formData = new FormData();

  const fieldNameMap: { [key: string]: string } = {
    'proprietor_pan_image': 'transaction_image',
    'proprietor_gst_image': 'transaction_image',
    'director_aadhar_front_image': 'transaction_image',
    'director_aadhar_back_image': 'transaction_image',
    'director_pan_image': 'transaction_image',
    'director_gst_image': 'transaction_image',
    'director_aadhar_front_imageone': 'transaction_image',
    'director_aadhar_back_imageone': 'transaction_image',
    'director_pan_imageone': 'transaction_image',
    'cin_number_image': 'transaction_image',
    'profile_picture': 'transaction_image'
  };

  const apiFieldName = fieldNameMap[imageKey] ?? imageKey;
  formData.append(apiFieldName, file, file.name);

  this.home.imgUpload(formData).subscribe({
    next: (res: any) => {
      const uploadedUrl = res[imageKey]
        ?? res['transaction_image']
        ?? res?.data?.[imageKey]
        ?? res?.data?.url
        ?? res?.url
        ?? res?.path
        ?? res?.image_url;

      if (uploadedUrl) {
        form.get(imageKey)?.setValue(uploadedUrl);
        form.get(imageKey)?.markAsDirty();
        form.get(imageKey)?.markAsTouched(); // success తర్వాతే — error చూపించదు
      } else {
        console.error('Could not find URL in response:', res);
        form.get(imageKey)?.markAsTouched(); // genuine error
        this.toast.error({ detail: 'Upload Failed', summary: `Could not upload document.`, position: 'topCenter' });
      }
    },
    error: (err) => {
      console.error('Upload error:', err.error);
      form.get(imageKey)?.markAsTouched();
      this.toast.error({ detail: 'Upload Failed', summary: `Upload failed. Please try again.`, position: 'topCenter' });
    }
  });
}
  onFileSelectedPvt(event: any, imageKey: string, previewUrlKey: string) {
    this.selectedFile = event.target.files[0];
    const formData = new FormData();
    formData.append(imageKey, this.selectedFile);
    this.home.imgUpload(formData).subscribe((res: any) => {
      this.pvtForm.get(imageKey)?.setValue(res[imageKey]);
      // Set the previewUrl dynamically
      this.previewUrls[previewUrlKey] = res[previewUrlKey];
      this.previewImage(previewUrlKey);

    });
  }
  previewImage(previewUrlKey: string) {
    if (!this.selectedFile) {
      this.previewUrls[previewUrlKey] = null;
      return;
    }
  
    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = () => {
      this.previewUrls[previewUrlKey] = reader.result as string;
    };
  }
  
  
  
  ngOnInit(): void {
    this.kycGet();
   }
  // onSubmit() {
  //   this.home.kycPost(this.propriotorForm.value).subscribe((res: any) => {
  //     this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
  //     this.isSubmit = true;
  //     this.propriotorForm.reset();
  //   });
  // }

  onSubmit() {
    debugger;
  if (this.propriotorForm.invalid) return; // safety guard

  this.home.kycPost(this.propriotorForm.value).subscribe({
    next: (res: any) => {
      this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
      this.isSubmit = true;
      this.propriotorForm.reset();
      // this.previewUrls = {}; // clear previews after reset
      //  this.router.navigate(['/kyc_details']);
        setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    error: (err) => {
      console.error('KYC submit error:', err.error);
      this.toast.error({ detail: 'Error!', summary: err.error?.msg || 'Submission failed', position: 'topCenter' });
    }
  });
}
  // onOtherSubmit() {
  //   this.home.kycPost(this.otherForm.value).subscribe((res: any) => {
  //     this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
  //     this.isSubmit = true;
  //     this.otherForm.reset();
  //   });
  // }
  // onPvtSubmit() {
  //   this.home.kycPost(this.pvtForm.value).subscribe((res: any) => {
  //     this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
  //     this.isSubmit = true;
  //     this.pvtForm.reset();
  //   });
  // }


  onOtherSubmit() {
  debugger;
  if (this.otherForm.invalid) return; // safety guard

  this.home.kycPost(this.otherForm.value).subscribe({
    next: (res: any) => {
      this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
      this.isSubmit = true;
      this.otherForm.reset();
      this.previewUrls = {}; // clear previews after reset
      this.router.navigate(['/kyc_details']);
    },
    error: (err) => {
      console.error('KYC submit error:', err.error);
      this.toast.error({ detail: 'Error!', summary: err.error?.msg || 'Submission failed', position: 'topCenter' });
    }
  });
}

onPvtSubmit() {
  debugger;
  if (this.pvtForm.invalid) return; // safety guard

  this.home.kycPost(this.pvtForm.value).subscribe({
    next: (res: any) => {
      this.toast.success({ detail: 'Success!', summary: res.msg, position: 'topCenter' });
      this.isSubmit = true;
      this.pvtForm.reset();
      this.previewUrls = {}; // clear previews after reset
      this.router.navigate(['/kyc_details']);
    },
    error: (err) => {
      console.error('KYC submit error:', err.error);
      this.toast.error({ detail: 'Error!', summary: err.error?.msg || 'Submission failed', position: 'topCenter' });
    }
  });
}
  // selectType(event: any) {
  //   if (event.target.value === 'Proprietor') {
  //     this.pvtForm.reset();
  //     this.otherForm.reset();
  //     this.propriotorForm.reset();
  //     this.isProprietor = true;
  //     this.isPvt = false;
  //     this.isLpp = false;
  //     this.propriotorForm.get('business_type')?.setValue(event.target.value);
  //   } else if (event.target.value === 'LLP') {
  //     this.pvtForm.reset();
  //     this.otherForm.reset();
  //     this.propriotorForm.reset();
  //     this.isProprietor = false;
  //     this.isPvt = false;
  //     this.isLpp = true;
  //     this.otherForm.get('business_type')?.setValue(event.target.value);
  //   }
  //   else {
  //     this.pvtForm.reset();
  //     this.otherForm.reset();
  //     this.propriotorForm.reset();
  //     this.isPvt = true;
  //     this.isProprietor = false;
  //     this.isLpp = false;
  //     this.pvtForm.get('business_type')?.setValue(event.target.value);
  //   }
  // }


  selectType(event: any) {
  // clear all image previews
  this.previewUrls = {};

  if (event.target.value === 'Proprietor') {
    this.pvtForm.reset();
    this.otherForm.reset();
    this.propriotorForm.reset();
    this.isProprietor = true;
    this.isPvt = false;
    this.isLpp = false;
    this.propriotorForm.get('business_type')?.setValue(event.target.value);
  } else if (event.target.value === 'LLP') {
    this.pvtForm.reset();
    this.otherForm.reset();
    this.propriotorForm.reset();
    this.isProprietor = false;
    this.isPvt = false;
    this.isLpp = true;
    this.otherForm.get('business_type')?.setValue(event.target.value);
  } else {
    this.pvtForm.reset();
    this.otherForm.reset();
    this.propriotorForm.reset();
    this.isPvt = true;
    this.isProprietor = false;
    this.isLpp = false;
    this.pvtForm.get('business_type')?.setValue(event.target.value);
  }

  // clear native file input elements (form.reset() won't clear these)
  this.clearFileInputs();
}

clearFileInputs() {
  const fileInputs = document.querySelectorAll('input[type="file"]');
  fileInputs.forEach((input: any) => {
    input.value = '';
  });
}
}
